var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCiritcalBatteryTempIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 5.5L11.5 5.5M14.5 7.5L11.5 7.5M14.5 9.5L11.5 9.5M6.75 10.8789V6.25C6.75 5.55964 7.30964 5 8 5C8.69036 5 9.25 5.55964 9.25 6.25V10.8789C9.85299 11.2825 10.25 11.9699 10.25 12.75C10.25 13.9926 9.24264 15 8 15C6.75736 15 5.75 13.9926 5.75 12.75C5.75 11.9699 6.14701 11.2825 6.75 10.8789ZM8.5 12.75C8.5 13.0261 8.27614 13.25 8 13.25C7.72386 13.25 7.5 13.0261 7.5 12.75C7.5 12.4739 7.72386 12.25 8 12.25C8.27614 12.25 8.5 12.4739 8.5 12.75Z",
    stroke: "#F04438",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiritcalBatteryTempIcon);
export default __webpack_public_path__ + "static/media/ciritcal-battery-temp-icon.596218ee5160b9994a5ae8857076f45c.svg";
export { ForwardRef as ReactComponent };